const PrivacyPolicy = () => {
    const nomeHost = process.env.REACT_APP_HOSTNOMECOMPLETO;
    const emailContatto = process.env.REACT_APP_EMAILCONTATTO;

    const paragrafi = [
        "Il presente sito raccoglie i seguenti dati personali tramite il form di contatto: Nome, Email, Numero di Telefono.",
        "Questi dati vengono utilizzati esclusivamente per rispondere alle richieste di contatto inviate dall'utente. Non conserviamo i dati personali dopo aver risposto alla richiesta.",
        `Il Titolare del trattamento dei dati è ${nomeHost}.`,
        `L'utente ha il diritto di richiedere in qualsiasi momento la cancellazione dei propri dati personali inviando una richiesta all'indirizzo email: ${emailContatto}.`,
    ];

    return (
        <div className="px-4 py-6">
            {/* Titolo Principale */}
            <h1 className="text-3xl font-bold text-center mb-6">Privacy Policy</h1>

            {/* Sezione Informazioni */}
            <div className="listingSection__wrap">
                <h2 className="text-2xl font-semibold mb-4">L'utilizzo di questo sito è soggetto alle seguenti Privacy Policy</h2>
                {paragrafi.map((testo, index) => (
                    <p
                        key={index}
                        className="text-neutral-6000 dark:text-neutral-300 mb-4"
                    >
                        {testo}
                    </p>
                ))}
            </div>
        </div>
    );
};

export default PrivacyPolicy;
